import { inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpInterceptorFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { LoginService } from './login.service';
import { catchError } from 'rxjs/operators';
import { getHttpErrorCode } from '../shared/http-error.util';
import { AuthObservabilityService } from '../shared/monitoring/auth-observability.service';

function addAuthHeader(request: HttpRequest<unknown>, loginService: LoginService): HttpRequest<unknown> {
  if (loginService.getToken()) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${loginService.getToken()}`,
      },
    });
  }
  return request;
}

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const loginService = inject(LoginService);
  const authObservability = inject(AuthObservabilityService);

  request = addAuthHeader(request, loginService);

  return next(request).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.error) {
        switch (getHttpErrorCode(err.error)) {
          case 'T001':
            loginService.refresh(err.headers.get('token-renewed'));
            authObservability.trackTokenRefreshed();
            request = addAuthHeader(request, loginService);
            return next(request);
          case 'T002':
            authObservability.trackAccessDenied();
            loginService.logout();
            break;
        }
      }

      return throwError(() => err);
    })
  );
};
